import { render } from "./SemesterSchoolyearDialog.vue?vue&type=template&id=0c91542d"
import script from "./SemesterSchoolyearDialog.vue?vue&type=script&lang=js"
export * from "./SemesterSchoolyearDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__